<template>
    <div>
        <div v-for="selectedItem in selectedItems" :key="selectedItem.contract_id || selectedItem.id" class="my-4 p-4">
            <div class="flex">
                <p class="w-320 mr-24 truncate">{{ selectedItem.name }}</p>
                <p v-if="!Number.isNaN(selectedItem.price.amount) && selectedItem.price.amount > 0 && selectedItem.price.currency !== 'credits'" class="min-w-fit mr-36"><currency/>{{ selectedItem.price.amount.toFixed(2) }}</p>
                <p v-else class="min-w-fit mr-36">{{ $t('multi-posting.price.free') }}</p>
                <p class="flex items-center mr-36">
                    <svg-icon type="calendar-today" class="w-20 h-20 mr-8" />
                    <span>{{ duration(selectedItem) }}</span>
                </p>
                <p class="flex items-center">
                    <svg-icon type="material-clock" class="w-20 h-20 mr-8" />
                    <span class="lowercase">{{ deliverTime(selectedItem) }}</span>
                </p>
            </div>
        </div>
    </div>
</template>
<script>
import Currency from "../../Currency.vue";
import {mapState} from "pinia";
import SvgIcon from "../../ui/SvgIcon.vue";
import {useMultiPostingStore} from "../../../state/modules/multiPosting";

export default {
    name: "Channels",
    components: {Currency, SvgIcon},
    computed: {
        ...mapState(useMultiPostingStore, ['selectedItems']),
    },
    methods: {
        duration(item) {
            return `${item.duration.period} ${item.duration.range ?? this.$tc('general.days', item.duration.period).toLowerCase()}`;
        },
        deliverTime(item) {
            // always in hours
            if (item.type === "socialChannel") return `5 ${this.$tc('general.working_days', 5)}`
            if (!item.time_to_process && !item.time_to_setup) return this.$t('multi-posting.duration.immediately');
            const duration = item.time_to_process + item.time_to_setup;
            if (duration < 24)
                return `${duration} ${this.$tc('general.hours', duration)}`;
            const days = Math.floor(duration / 24);
            return `${days} ${this.$tc('general.working_days', days)}`;
        },
    }
}
</script>